const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/sikring/$sikringId/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId,
      sikringId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].sikring[":sikringId"].$get({
      param: {
        tluxCaseId,
        sikringId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch sikring");
    }
    return {
      sikring: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Rediger sikring | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});